import { useSoftDeployAccess } from './featureHelper';

const useMultiLLMProviderAccess = (): boolean => useSoftDeployAccess('MULTI_LLM_PROVIDER');

export default useMultiLLMProviderAccess;
